import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Popup = styled.div`
  max-height: 400px;
  overflow-y: auto;
  position: absolute;
  z-index: 11;
  padding: 20px;
  width: 100%;
  border: solid 1px #a3b0c0;
  border-radius: 4px;
  background-color: #4f5761;
  top: 42px;
  left: 0;
  display: ${(props) => (props.popupIsOpen ? 'block !important' : 'none !important')};
`;

export const Checkbox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  &:last-child {
    margin-bottom: 0;
  }
  &.checkbox {
    input {
      margin-right: 15px;
      appearance: none;
      outline: none;
      cursor: pointer;
      width: 14px;
      height: 14px;
      border-radius: 4px;
      border: 1px solid #fff;
      opacity: 1;
      :checked {
        background-image: url('/images/checkbox-checked.png');
        background-size: cover;
        background-repeat: no-repeat;
        background-color: #fff;
        border: none;
      }
    }
    label {
      font-size: 15px;
      color: #fff;
      opacity: 1;
    }
  }
`;

export const InputBox = styled.div`
  position: relative;
  height: 100%;
  &:after {
    content: '';
    position: absolute;
    top: 12px;
    right: 5px;
    width: 6px;
    height: 6px;
    border: 2px solid #bebebe;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  input {
    text-overflow: ellipsis;
    padding-right: 20px;
  }
`;

export const Select = styled.div`
  height: 100%;
  position: relative;
`;
